export default __webpack_public_path__ + "static/media/35.982df093.png";